import { Controller } from "@hotwired/stimulus"
import flatpickr from "flatpickr"

// Date picker on a Bootstrap input-group (flatpickr "wrap" mode: the input has
// data-input, the calendar button data-toggle).
export default class extends Controller {
  static values = { format: { type: String, default: "d.m.Y" } }

  connect() {
    this.picker = flatpickr(this.element, {
      wrap: true,
      dateFormat: this.formatValue,
      allowInput: true,
      locale: "pl"
    })
  }

  disconnect() {
    this.picker?.destroy()
  }
}
